<template>
  <div class="box flex flex-col gap-1 px-4 py-3">
    <div class="flex flex-row items-center gap-2">
      <span
        class="h-4 w-4 shrink-0 squircle-xl rounded-md"
        :class="bulletClass"
      ></span>
      <h3
        class="line-clamp-1 text-base leading-tight font-medium capitalize-first"
      >
        {{ eventTitleFormated }}
      </h3>
    </div>
    <div class="flex flex-col gap-0.5 text-sm text-gray-600 dark:text-gray-300">
      <div
        v-if="event.date_from && event.type !== 'ASR'"
        class="flex items-center gap-2"
      >
        <font-awesome-icon :icon="['fal', 'calendar-minus']" fixed-width />
        <span>
          {{ event.date_from }}
          <template v-if="event.type === 'CON' && event.date_to">
            &gt; {{ event.date_to }}
          </template>
        </span>
      </div>
      <div
        v-if="event.date_to && event.type === 'ASR'"
        class="flex items-center gap-2"
      >
        <font-awesome-icon :icon="['fal', 'calendar-minus']" fixed-width />
        <span>{{ event.date_to }}</span>
      </div>
      <div
        v-if="
          event.type !== 'CON' &&
          event.type !== 'ASR' &&
          event.time_from &&
          event.time_to
        "
        class="flex items-center gap-2"
      >
        <font-awesome-icon :icon="['fal', 'clock']" fixed-width />
        <span>
          {{ event.time_from }}
          <template v-if="event.type !== 'CAR'">
            &gt; {{ event.time_to }}
          </template>
        </span>
      </div>
      <div
        v-if="event.asset_id && event.type !== 'CRE'"
        class="flex items-center gap-2"
      >
        <font-awesome-icon :icon="['fal', 'map-marker-alt']" fixed-width />
        <span>{{ assetName }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'WorkPreviewEvent',
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({ metadata: 'work/getWorkMetadata' }),
    bulletClass() {
      return 'bg-theme-' + this.event.type
    },
    eventTitleFormated() {
      return this.event.type
        ? this.$t(`enums.event.type.${this.event.type}`)
        : this.$t('global.new_event')
    },
    assetName() {
      if (this.event.asset_id !== null) {
        return (
          this.metadata?.events?.assets?.find(
            (asset) => asset.id === this.event.asset_id
          )?.name ?? ''
        )
      }
      return ''
    }
  }
}
</script>
